// import { employeeReducer } from "./employee/employee-reducer";
// import { serviceReducer } from "./services/services-reducer";
// import {amenitiesReducer} from './amenities/amenities-reducer'
// import {subscriptionReducer} from "./subscription/subscription-reducer"
// import { branchReducer } from "./branch/branch-reducer";
// import { partnerReducer } from "./partner/partner-reducer";
import { partnerProfileReducer } from "./partner-profile/profile-reducer";



export const PARTNER_ROOT_REDUCER={
    // employees: employeeReducer,
    // services:serviceReducer,
    // amenities:amenitiesReducer,
    // subscription:subscriptionReducer,
    // branch:branchReducer,
    profileInfo:partnerProfileReducer
}